import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

const styles = theme => ({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '30px',
    '&:before': {
      content: '',
      position: 'absolute',
      zIndex: -1,
      top: '32px',
      height: '100%',
      left: '50%',
      marginLeft: '-5px',
      width: '10px',
      background: 'blue'
    }
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  chip: {
    height: '30px',
    width: '100%',
    color: theme.palette.primary.main
  }
})
class HeaderHistoryComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classnames('headerTimeline', classes.container)}>
        <div className={classes.chipContainer}>
          <Chip label="Maintenant" className={classes.chip} />
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(HeaderHistoryComponent)



// WEBPACK FOOTER //
// ./src/routes/History/components/HeaderHistoryComponent.js